var bighouse = bighouse || {};

bighouse.booking2 = (function() {

  function init(){

    //enabling / disabling [+] currently affects all - needs to be aware of the parents.
   
    $('.js-increment').each(function(e){

      var self = this;
      var maxValue = parseInt( $(self).attr('data-max'), 10);
      var id = self.id;
      //if the attribute exists, pull in the price

      $(self).find(".js-changeCount").on("click", function(e) {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        var newVal = 0;
        var incrementButton = ".FormCounter-button--increment";
        var decrementButton = ".FormCounter-button--decrement";

        var newSum = sumGuests(self); //added this so it only does it once. should it happen more? new / old val?
       
        if ($button.text() == "+") {
          
          if (newSum < maxValue) {     
            newVal = parseFloat(oldValue) + 1;              
          } else { 
            newVal = oldValue;          
          }
              
          $button.parent().find("input").val(newVal);
          newSum =sumGuests(self);
          checkMaxValue(incrementButton, newSum, maxValue, id);
  
          if(newVal > 0){
            enableButton($button, decrementButton)
          }
  
        } else { 
          if (oldValue > 0) {
            newVal = parseFloat(oldValue) - 1; 
           
            if(newVal == 0){                    
              disableButton($button, decrementButton)         
            }   
  
          } else { newVal = 0; }
                
          $button.parent().find("input").val(newVal);
          newSum =sumGuests(self);
          checkMaxValue(incrementButton, newSum, maxValue, id);  
        }
       
        $(self).find(".js-total").text(sumGuests(self));
       
      });
    });
  }

  function checkMaxValue(incrementButton, newSum, maxValue, id){
    if(newSum == maxValue){
      $('#'+ id).find(incrementButton).addClass("disabled");
    }
    else{
      $('#'+ id).find(incrementButton).removeClass("disabled");
    }
  }

  function sumGuests(currentGroup) {
    var totalGuests = 0;
    $(currentGroup).find(".FormCounter-input").each(function(index) {
      totalGuests = totalGuests + parseFloat($(this).val());
    });
    return totalGuests;
  }

  function disableButton($button, buttontype){
    $button.parent().find(buttontype).addClass("disabled")
  }

  function enableButton($button, buttontype){
    $button.parent().find(buttontype).removeClass("disabled")
  }
  
  return {
    init: init
  };
})();
